"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityValidator = exports.EntityValidatorKeys = void 0;
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
/**
 * @deprecated Don't use oo modelling anymore. Use simple types or `shared-modelling` instead.
 */
var EntityValidatorKeys;
(function (EntityValidatorKeys) {
    EntityValidatorKeys["equalValues"] = "values do not equal";
})(EntityValidatorKeys = exports.EntityValidatorKeys || (exports.EntityValidatorKeys = {}));
/**
 * @deprecated Don't use oo modelling anymore. Use simple types or `shared-modelling` instead.
 */
class EntityValidator {
    /**
     * Validates if given objects equal.
     *
     * @param item1 The item to check equality
     * @param item2 The other item to check equalityf
     * @param [key=ValidatorKeys.equalValues] If caller (e.g. higher validator) wants to overwrite
     * the key
     * @returns The validator result
     */
    static hasEqualValues(item1, item2, key = EntityValidatorKeys.equalValues) {
        return echain_shared_validation_1.Validation.create(item1.hasEqualValues(item2), key);
    }
}
exports.EntityValidator = EntityValidator;
//# sourceMappingURL=EntityValidator.js.map